import React, { SetStateAction, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { Box, MenuItem, Paper, Select, Snackbar, Stack, TextField, Typography } from "@mui/material";
import { TableFooter, TablePagination } from "@mui/material";
import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { TableContainer } from "@mui/material";
import TablePaginationActions from "../../../Components/Pagination/pagination";
import { StyledTableHead, StyledTableCell, } from "../../../Styles/tabelCellStyled/customTableCell";
import { IAplicacaoEP } from "../../../Interfaces/cadernos/caderno11";
import { CustomSelect, CustomTextField, CustomThemeProvider, } from "../../../Styles/theme/customThemeprovider";
import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { desformatarNumero_return_null, formatarNumero_ao_digitar, desformatarNumero } from "../../../Func_genericas/formatar_numero_formato_pt";
import BasicPopover from "../../../Components/Popover";
import { unidade_medida_Km3_t } from "../../../informacao_estatica";
import { Alert } from "../../../Components/Alert/Alert";
import { formatar_numeros_tabela_tres_11 } from "../../../Componentes_modulo/FuncoesFormatarNumeroPT/cadernos/cadernos11";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { IZonaHomogenea } from "../../../Interfaces/cadernos/zona_homogenea";
import { mensagem_tem_a_certeza_de_apagar_alteracoes } from "../../../Func_genericas/valores_estaticos";


interface IAplicacaoEPProps {
  obj_aplicacaoEP: IAplicacaoEP | undefined;
  set_obj_aplicacaoEP: React.Dispatch<SetStateAction<IAplicacaoEP | undefined>>;
  rows: IAplicacaoEP[];
  setRows: React.Dispatch<SetStateAction<IAplicacaoEP[]>>;
  rows_filtrada: IAplicacaoEP[];
  setRows_filtrada: React.Dispatch<SetStateAction<IAplicacaoEP[]>>;
}

export const AplicacaoEPForm: React.FC<IAplicacaoEPProps> = ({
  obj_aplicacaoEP,
  set_obj_aplicacaoEP,
  rows,
  setRows,
  rows_filtrada,
  setRows_filtrada,
}) => {
  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const auth = useContext(AuthContext);
  const [message, setMessage] = React.useState("");
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showNewRow, setShowNewRow] = useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);

  const [especie_ou_lote_homegenio_selecionada, set_especie_ou_lote_homegenio_selecionada] = useState<IZonaHomogenea>();
  const [especie_ou_lote_homegenio_lista, set_especie_ou_lote_homegenio_lista] = useState<IZonaHomogenea[]>([]);

  const [error_propria, set_error_propria] = useState<boolean>(false);
  const [error_contratualizada, set_error_contratualizada] = useState<boolean>(false);
  const [error_quant, set_error_quant] = useState<boolean>(false);
  const [error_data, set_error_data] = useState<boolean>(false);
  const message_apenas_numero = ("Apenas números são aceites");

  const camposNumericos = ["propria", "contratualizada", "quant"];
  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    handleCancel()


    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };
  async function getTabela() {
    setIsLoading(true);
    try {
      let res = await get(auth.token.cookie_token, `/get_reg_gest_fluentes_onze_tres_rosto/${location.state.id_rosto}`);
      if (res.status === 200) {
        const formattedData = res.data.result.map(formatar_numeros_tabela_tres_11);
        setRows(formattedData);
        setRows_filtrada(formattedData);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("getAgua", error, true);
      setIsLoading(false);
    }
  }

  async function getListaZonasHomogeneas() {
    try {
      setIsLoading(true);
      let res = await get(auth.token.cookie_token, `/get_caraterizacao_id_rosto/${location.state.id_rosto}`);
      // filtrar parcelas unicas
      if (res.status === 200 && res.data.result.length !== 0) {
        set_especie_ou_lote_homegenio_lista(res.data.result);
        set_especie_ou_lote_homegenio_selecionada(res.data.result[0])
      }
      setIsLoading(false);

    } catch (error) {
      func_print("getCabecalhoFitossanitaria", error, true);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    (async () => {
      await getTabela();
      await getListaZonasHomogeneas();
    })();
  }, []);

  //Criar
  const handleCancel = () => {
    setShowNewRow(false);
    set_obj_aplicacaoEP(undefined);
    set_error_data(false)
  }

  const onInputChange = (event: any) => {
    const { name, value } = event.target;
    const isCampoNumerico = camposNumericos.includes(name);
    set_flag_editado(true)

    if (name === "data") {
      if (value === undefined || value === "") {
        set_error_data(true);
      } else {
        set_error_data(false);
      }
    }

    if (isCampoNumerico) {
      const valorSemFormatar = value.replace(/[^\d,]/g, "");
      const valorNumerico = parseFloat(value.replace(",", "."));

      if (!isNaN(valorNumerico)) {
        if (name === "propria") {
          set_error_propria(false);
        } else if (name === "contratualizada") {
          set_error_contratualizada(false);
        } else if (name === "quant") {
          set_error_quant(false);
        }
      } else {
        if (name === "propria") {
          set_error_propria(true);
        } else if (name === "contratualizada") {
          set_error_contratualizada(true);
        } else if (name === "quant") {
          set_error_quant(true);
        }
      }
      set_obj_aplicacaoEP((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: formatarNumero_ao_digitar(valorSemFormatar),
      }));
    } else {
      set_obj_aplicacaoEP((prevAzoto: any) => ({
        ...prevAzoto,
        [name]: value,
      }));
    }
  };

  const handleSave = async () => {

    if (obj_aplicacaoEP === undefined) {
      set_error_data(true)

      setMessage("Preencha a tabela antes de gravar!");
      setOpenSnackError(true);
    } else if(obj_aplicacaoEP.data === undefined || obj_aplicacaoEP.data === "") {
      set_error_data(true)

      setMessage("Preencha a data da aplicação!");
      setOpenSnackError(true);

    }else {
      try {
        setIsLoading(true);
        let res = await post(auth.token.cookie_token, "new_reg_gest_fluentes_onze_tres", {
          payload: {
            id_fluentes_tres: 0,
            n_parcelario: especie_ou_lote_homegenio_selecionada?.parcela_numero === undefined ? null : especie_ou_lote_homegenio_selecionada?.parcela_numero,
            cultura: especie_ou_lote_homegenio_selecionada?.cultura === undefined ? "" : especie_ou_lote_homegenio_selecionada.cultura,
            propria: obj_aplicacaoEP.propria === undefined ? 0 : desformatarNumero(obj_aplicacaoEP.propria),
            contratualizada: obj_aplicacaoEP.contratualizada === undefined ? 0 : desformatarNumero(obj_aplicacaoEP.contratualizada),
            tipo: obj_aplicacaoEP.tipo === undefined ? "" : obj_aplicacaoEP.tipo,
            origem: obj_aplicacaoEP.origem === undefined ? "" : obj_aplicacaoEP.origem,
            data: obj_aplicacaoEP.data === undefined ? null : obj_aplicacaoEP.data,
            quant: obj_aplicacaoEP.quant === undefined ? 0 : desformatarNumero(obj_aplicacaoEP.quant),
            medida: obj_aplicacaoEP.medida === undefined ? "" : obj_aplicacaoEP.medida,
            id_rosto: location.state.id_rosto,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });

        if (res.status === 200) {
          setMessage("Gravado com sucesso!");
          set_flag_editado(false)

          setRows((rows) => [...rows, formatar_numeros_tabela_tres_11(res.data.result)]);
          setRows_filtrada((rows) => [...rows, formatar_numeros_tabela_tres_11(res.data.result)]);
          set_obj_aplicacaoEP(undefined);
          setOpenSnackSuccess(true);
          setShowNewRow(false);
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error) {
        func_print("handleSaveAgua", error, true);
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
        setIsLoading(false);
      }
    }
  };
  // Editar
  const handleEdit = (obj: IAplicacaoEP) => {
    set_obj_aplicacaoEP(obj);
    let aux_obj_zona_homogenea_selecionada = especie_ou_lote_homegenio_lista?.find((el: IZonaHomogenea) => el.parcela_numero === obj.n_parcelario)

    if (aux_obj_zona_homogenea_selecionada !== undefined) {
      set_especie_ou_lote_homegenio_selecionada(aux_obj_zona_homogenea_selecionada)
    }
  };



  const handleUpdate = async () => {

    try {
      let res = await post(auth.token.cookie_token, "update_reg_gest_fluentes_onze_tres", {
        payload: {
          id_fluentes_tres: obj_aplicacaoEP?.id_fluentes_tres,
          n_parcelario: obj_aplicacaoEP?.n_parcelario === undefined ? null : (obj_aplicacaoEP?.n_parcelario),
          cultura: obj_aplicacaoEP?.cultura === undefined ? "" : obj_aplicacaoEP?.cultura,
          propria: obj_aplicacaoEP?.propria === undefined ? null : desformatarNumero_return_null(obj_aplicacaoEP?.propria),
          contratualizada: obj_aplicacaoEP?.contratualizada === undefined ? null : desformatarNumero_return_null(obj_aplicacaoEP?.contratualizada),
          tipo: obj_aplicacaoEP?.tipo === undefined ? "" : obj_aplicacaoEP?.tipo,
          origem: obj_aplicacaoEP?.origem === undefined ? "" : obj_aplicacaoEP?.origem,
          data: obj_aplicacaoEP?.data === undefined ? null : obj_aplicacaoEP?.data,
          quant: obj_aplicacaoEP?.quant === undefined ? null : desformatarNumero_return_null(obj_aplicacaoEP?.quant),
          medida: obj_aplicacaoEP?.medida === undefined ? "" : obj_aplicacaoEP?.medida,
          id_rosto: obj_aplicacaoEP?.id_rosto,
          last_update: new Date().toISOString(),
          create_date: obj_aplicacaoEP?.create_date,
          uuid: obj_aplicacaoEP?.uuid,
        }
      });

      if (res.status === 200) {
        setMessage("Registado com sucesso!");
        set_flag_editado(false)

        const updatedRows = rows.map((row) => {
          if (row.id_fluentes_tres === obj_aplicacaoEP?.id_fluentes_tres) {
            return formatar_numeros_tabela_tres_11(res.data.result)
          } else {
            return row;
          }
        });
        setRows(updatedRows !== undefined ? updatedRows : []);
        setRows_filtrada(updatedRows !== undefined ? updatedRows : []);
        set_obj_aplicacaoEP(undefined);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleUpdateAgua", error, true);
      setMessage("Erro ao gravar!");
      setOpenSnackError(true);
      setIsLoading(false);
    }


  };

  // DELETE
  const handleClickOpenDelete = (obj: IAplicacaoEP) => {
    set_obj_aplicacaoEP(obj);
    setOpenDelete(true);
  };

  const handleDelete = async () => {
    try {
      setIsLoading(true);
      let res = await del(auth.token.cookie_token, `/delete_gest_fluentes_onze_tres/${obj_aplicacaoEP?.id_fluentes_tres}`);

      if (res.status === 200) {
        setMessage("Eliminado com sucesso!");
        setRows((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_fluentes_tres !== obj_aplicacaoEP?.id_fluentes_tres),
        ]);
        setRows_filtrada((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_fluentes_tres !== obj_aplicacaoEP?.id_fluentes_tres),
        ]);
        set_obj_aplicacaoEP(undefined)
        setOpenDelete(false);
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleDeleteAgua", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  /*****************  PAGINAÇÃO ********************** */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows_filtrada.length) : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handle_change_zona_homogenea = (sub_parcela_selecionada: number) => {

    let aux_obj_zona_homogenea_selecionada = especie_ou_lote_homegenio_lista.find((el: IZonaHomogenea) => el.parcela_numero.toString() === sub_parcela_selecionada.toString())
    if (aux_obj_zona_homogenea_selecionada !== undefined) {

      set_especie_ou_lote_homegenio_selecionada(aux_obj_zona_homogenea_selecionada)
      set_obj_aplicacaoEP((prevOperacoes: any) => ({
        ...prevOperacoes,
        cultura: aux_obj_zona_homogenea_selecionada?.cultura,
        n_parcelario: aux_obj_zona_homogenea_selecionada?.parcela_numero,
      }));

    }


  }
  return (
    <CustomThemeProvider>
      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{
          height: "auto",
          width: "auto",
          margin: 2,
          padding: 2,
        }}
      >
        <Snackbar
          open={openSnackSuccess}
          autoHideDuration={2000}
          onClose={() => setOpenSnackSuccess(false)}
        >
          <Alert
            onClose={() => setOpenSnackSuccess(false)}
            severity="success"
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
        <Snackbar
          open={openSnackError}
          autoHideDuration={2000}
          onClose={() => setOpenSnackError(false)}
        >
          <Alert
            onClose={() => setOpenSnackError(false)}
            severity="error"
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
        <table style={{ width: "100%" }}>
          <TableHead>
            <TableRow>
              <TableCell
                colSpan={7}
                sx={{
                  fontWeight: 600,
                  textAlign: "left",
                  fontFamily: "candara",
                  fontSize: 16,
                }}
              >
                3 - Aplicação de efluentes pecuários.
              </TableCell>
              <TableCell colSpan={2}>
                <Box sx={{ display: "flex", justifyContent: "end" }}>
                  {is_historico === true ? <></> :

                    <BarraDeFerramentas
                      mostrarBotaoNovo
                      textoBotaoNovo="Novo Registo"
                      aoClicarNovo={() => {
                        set_obj_aplicacaoEP(undefined)
                        setShowNewRow(true)
                      }}
                    />}
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              <StyledTableHead rowSpan={2}>
                Identificação da Parcela (N.º Parcelário)
              </StyledTableHead>
              <StyledTableHead rowSpan={2}>Cultura </StyledTableHead>
              <StyledTableHead colSpan={2}>
                Áreas de aplicação dos efluentes (ha)
              </StyledTableHead>
              <StyledTableHead colSpan={4}>
                Aplicação de efluentes
              </StyledTableHead>
              <StyledTableHead rowSpan={2}>Ações</StyledTableHead>
            </TableRow>
            <TableRow>
              <StyledTableHead>Própria exploração</StyledTableHead>
              <StyledTableHead>Contratualizada</StyledTableHead>
              <StyledTableHead>Tipo</StyledTableHead>
              <StyledTableHead>Origem</StyledTableHead>
              <StyledTableHead>Data da Aplicação (dd/mm/aaaa)*</StyledTableHead>
              <StyledTableHead>
                <Stack direction="row" justifyContent="left" alignItems="center">
                  Quantidade (m3 ou t)
                  <BasicPopover text={"m3 refere-se à unidade de capacidade do chorume.\nt refere-se à unidade de peso do estrume"} />
                </Stack>
              </StyledTableHead>
            </TableRow>
          </TableHead>
          <TableBody>
            {showNewRow && (
              <TableRow>
                <StyledTableCell>
                  <Select
                    value={especie_ou_lote_homegenio_selecionada?.parcela_numero === undefined ? '' : especie_ou_lote_homegenio_selecionada?.parcela_numero}
                    label={''}
                    name={'parcela_numero'}
                    // defaultValue={especie_ou_lote_homegenio_selecionada?.id_cara === undefined ? 0 : especie_ou_lote_homegenio_selecionada?.id_cara}
                    sx={{
                      fontSize: 14,
                      fontFamily: "verdana",
                      minWidth: 200,
                    }}
                    onChange={(e) => handle_change_zona_homogenea(Number(e.target.value))}
                  >

                    {especie_ou_lote_homegenio_lista.map((item: IZonaHomogenea, key) => {

                      return (
                        <MenuItem key={key} value={item.parcela_numero}>
                          <Typography
                            style={{
                              fontSize: 14,
                              fontFamily: "candara",
                            }}
                          >
                            {item.parcela_numero}
                          </Typography>
                        </MenuItem>
                      );
                    })}
                  </Select>
                </StyledTableCell>
                <StyledTableCell>
                  {especie_ou_lote_homegenio_selecionada?.cultura}

                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="propria"
                    value={obj_aplicacaoEP?.propria}
                    onChange={onInputChange}
                    error={error_propria}
                    helperText={error_propria ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="contratualizada"
                    value={obj_aplicacaoEP?.contratualizada}
                    onChange={onInputChange}
                    error={error_contratualizada}
                    helperText={error_contratualizada ? message_apenas_numero : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="tipo"
                    value={obj_aplicacaoEP?.tipo}
                    onChange={onInputChange}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <CustomTextField
                    name="origem"
                    value={obj_aplicacaoEP?.origem}
                    onChange={onInputChange}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <TextField
                    variant="filled"
                    type="date"
                    name="data"
                    value={obj_aplicacaoEP?.data === undefined ? "" : obj_aplicacaoEP.data}
                    onChange={onInputChange}
                    error={error_data}
                    helperText={error_data ? "Campo obrigatório" : ""}
                  />
                </StyledTableCell>
                <StyledTableCell>
                  <Stack direction="row" alignItems="center">
                    <CustomTextField
                      name="quant"
                      value={obj_aplicacaoEP?.quant}
                      onChange={onInputChange}
                      error={error_quant}
                      helperText={error_quant ? message_apenas_numero : ""}
                    />
                    <CustomSelect
                      value={obj_aplicacaoEP?.medida !== undefined ? obj_aplicacaoEP.medida : ""}
                      name="medida"
                      onChange={onInputChange}
                      options={unidade_medida_Km3_t}
                      label="UM"
                      minWidth={50}
                    />
                  </Stack>
                </StyledTableCell>

                <StyledTableCell>
                  <Stack direction="row" justifyContent="center">
                    <ButtonCadernos
                      mostrarBotaoCancelar
                      aoClicarCancelar={() => {
                        if (flag_editado) {
                          set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                        } else {
                          handleCancel()
                        }
                      }}
                      mostrarBotaoGravar
                      aoClicarGravar={() => handleSave()}
                    />
                  </Stack>
                </StyledTableCell>
              </TableRow>
            )}

            {(rowsPerPage > 0
              ? rows_filtrada.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )
              : rows_filtrada
            ).map((row, key) => (
              <TableRow key={key}>
                {obj_aplicacaoEP?.id_fluentes_tres === row.id_fluentes_tres ? (
                  <>
                    <StyledTableCell>
                      <Select
                        value={especie_ou_lote_homegenio_selecionada?.parcela_numero === undefined ? '' : especie_ou_lote_homegenio_selecionada?.parcela_numero}
                        label={''}
                        name={'parcela_numero'}
                        // defaultValue={especie_ou_lote_homegenio_selecionada?.id_cara === undefined ? 0 : especie_ou_lote_homegenio_selecionada?.id_cara}
                        sx={{
                          fontSize: 14,
                          fontFamily: "verdana",
                          minWidth: 200,
                        }}
                        onChange={(e) => handle_change_zona_homogenea(Number(e.target.value))}
                      >

                        {especie_ou_lote_homegenio_lista.map((item: IZonaHomogenea, key) => {

                          return (
                            <MenuItem key={key} value={item.parcela_numero}>
                              <Typography
                                style={{
                                  fontSize: 14,
                                  fontFamily: "candara",
                                }}
                              >
                                {item.parcela_numero}
                              </Typography>
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </StyledTableCell>
                    <StyledTableCell>
                      {especie_ou_lote_homegenio_selecionada?.cultura}

                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="propria"
                        value={obj_aplicacaoEP?.propria}
                        onChange={onInputChange}
                        error={error_propria}
                        helperText={error_propria ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="contratualizada"
                        value={obj_aplicacaoEP?.contratualizada}
                        onChange={onInputChange}
                        error={error_contratualizada}
                        helperText={error_contratualizada ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="tipo"
                        value={obj_aplicacaoEP?.tipo}
                        onChange={onInputChange}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="origem"
                        value={obj_aplicacaoEP?.origem}
                        onChange={onInputChange}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <TextField
                        variant="filled"
                        type="date"
                        name="data"
                        value={obj_aplicacaoEP?.data === undefined ? "" : obj_aplicacaoEP?.data}
                        onChange={onInputChange}
                        error={error_data}
                        helperText={error_data ? "Campo obrigatório" : ""}
                      />
                    </StyledTableCell>
                    <StyledTableCell>
                      <CustomTextField
                        name="quant"
                        value={obj_aplicacaoEP?.quant}
                        onChange={onInputChange}
                        error={error_quant}
                        helperText={error_quant ? message_apenas_numero : ""}
                      />
                    </StyledTableCell>
                  </>
                ) : (
                  <>
                    <StyledTableCell>{row.n_parcelario} </StyledTableCell>
                    <StyledTableCell>{row.cultura} </StyledTableCell>
                    <StyledTableCell>{row.propria}</StyledTableCell>
                    <StyledTableCell>{row.contratualizada} </StyledTableCell>
                    <StyledTableCell>{row.tipo} </StyledTableCell>
                    <StyledTableCell>{row.origem}</StyledTableCell>
                    <StyledTableCell>{row.data}</StyledTableCell>
                    <StyledTableCell>{row.quant}{row.medida}</StyledTableCell>
                  </>
                )}
                {obj_aplicacaoEP?.id_fluentes_tres === row.id_fluentes_tres ? (
                  <StyledTableCell>
                    <ButtonCadernos
                      mostrarBotaoGravar
                      aoClicarGravar={() => handleUpdate()}
                      mostrarBotaoCancelar
                      aoClicarCancelar={() => {
                        if (flag_editado) {
                          set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                        } else {
                          handleCancel()
                        }
                      }}
                    />
                  </StyledTableCell>
                ) : (
                  <StyledTableCell>
                   { is_historico === true ? <></> :

                    <ButtonCadernos
                      mostrarBotaoEditar
                      aoClicarEditar={() => {
                        setShowNewRow(false)
                        handleEdit(row)
                      }}
                      mostrarBotaoApagar
                      aoClicarApagar={() => handleClickOpenDelete(row)}
                    />}
                  </StyledTableCell>
                )}
              </TableRow>
            ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell colSpan={12} />
              </TableRow>
            )}
          </TableBody>
          <TableFooter>
            <TableRow sx={{ width: "100%" }}>
              <TableCell>
                <Typography style={{ fontSize: 14, fontFamily: "candara" }}>
                  * Campos de preenchimento obrigatório
                </Typography>
              </TableCell>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                colSpan={14}
                count={rows_filtrada.length}
                rowsPerPage={rowsPerPage}
                page={page}
                labelDisplayedRows={({ from, to, count }) => {
                  return `${from}–${to} de ${count !== -1 ? count : `mais do que ${to}`}`;
                }}
                labelRowsPerPage={'Linhas por página'}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </table>
      </TableContainer>
      <ConfirmDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onConfirm={handleDelete}
        message="Deseja eliminar o registo?"
      />
      <ConfirmDialog
        open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
        onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
        onConfirm={() => handleCloseDialog()}
        message={mensagem_tem_a_certeza_de_apagar_alteracoes}
      />
    </CustomThemeProvider >
  );
};
